// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"5b2f08f8","787":"a32bf40d"}[chunkId] + ".chunk.js";
};